module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2019/february-70e267bd98c4e66e851101ce41a4b47f.png";